import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./en";
import { de } from "./de";
import { el } from "./el";
import { es } from "./es";
import { ja } from "./ja";
import { he } from "./he";
import { pl } from "./pl";
import { tr } from "./tr";
import { fr } from "./fr";
import { arSA } from "./ar-sa";
import {da} from "./da"

const languages = {
  de: de.translation,
  el: el.translation,
  en: en.translation,
  es: es.translation,
  he: he.translation,
  ja: ja.translation,
  pl: pl.translation,
  tr: tr.translation,
  fr: fr.translation,
  arSA: arSA.translation,
  da: da.translation,
};

i18n.use(initReactI18next).init({
  resources: languages,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
  fallbackLng: "en",
});
declare module "i18next" {
  interface CustomTypeOptions {
    resources: typeof en.translation;
  }
}

export default i18n;
